export type ExperimentConfig = {
  key: string;
  screenKey: string;
  fallback: string;
  /**
   * Variant names this app understands. Used only to reject stale localStorage
   * (e.g. renames). Backend responses are always trusted when present.
   */
  knownVariants: readonly string[];
};

/**
 * Sem experimentos ativos. O A/B de insights
 * (`screen_insights_old_vs_insights_new`) foi encerrado com a virada para a
 * tela nova — a infra fica de pé para o próximo.
 */
export const EXPERIMENTS_REGISTRY: ExperimentConfig[] = [];
